export default __webpack_public_path__ + "static/media/holepunching-icon-grayscale.a87d3fce.svg";